/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Row, Typography, Form, InputNumber } from "antd";

import { COLORS } from "~constants";
import { OvernighGuestContext } from "./context-form";

const { Paragraph } = Typography;

const Index = () => {
  /*
   *  -- NOTE --
   *
   *   This Form is only use for Overnight Guest Page and is
   *   Tightly coupled with the context of Overnight Guest Form
   *
   * * */

  const store = useContext(OvernighGuestContext);

  const [totalGenderCount, settotalGenderCount] = useState();
  const [totalGuestNight, settotalGuestNight] = useState();
  const [failed, setisFailed] = useState(false);
  const { overnightGuestValues, isFailed } = useContext(OvernighGuestContext);

  useEffect(() => {
    let _totalGenderCount = { totalMale: 0, totalFemale: 0 };
    Object.keys(overnightGuestValues).forEach((key) => {
      if (key === "nonPhResident" || key === "ofwResident") {
        overnightGuestValues[key].forEach((item) => {
          _totalGenderCount.totalMale += item?.male || 0;
          _totalGenderCount.totalFemale += item?.female || 0;
        });
      } else if (key !== "lengthOfStay") {
        _totalGenderCount.totalMale += overnightGuestValues[key].male;
        _totalGenderCount.totalFemale += overnightGuestValues[key].female;
      }
    });

    let totalGuest =
      _totalGenderCount.totalMale +
      _totalGenderCount.totalFemale +
      overnightGuestValues["lengthOfStay"]["guestExtending"];

    settotalGenderCount(_totalGenderCount);
    settotalGuestNight(totalGuest);
  }, [overnightGuestValues]);

  useEffect(() => {
    setisFailed(isFailed);
  }, [store]);

  return (
    <>
      {failed && (
        <Row justify="center" align="center">
          <Paragraph type="danger">
            <b>Error Submitting Report:</b>
            &nbsp;Please check input fields and make sure you didn't miss
            anything
          </Paragraph>
        </Row>
      )}
      <Row gutter={10} justify="space-between" align="center">
        <Col span={12}>No. of Occupied Rooms</Col>
        <Col span={12}>
          <Form.Item
            rules={[
              {
                required: true,
                message: `Please input No. of Occupied Rooms`,
              },
            ]}
            name={["lengthOfStay", "noOccupiedRooms"]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10} justify="space-between" align="center">
        <Col span={12}>No. of Available Rooms</Col>
        <Col span={12}>
          <Form.Item
            rules={[
              {
                required: true,
                message: `Please input No. of Available Rooms`,
              },
            ]}
            name={["lengthOfStay", "noAvailableRooms"]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10} justify="space-between" align="center">
        <Col span={12}>Guest Checkin</Col>
        <Col span={12}>
          <Form.Item>
            <Paragraph style={{ paddingLeft: 12 }}>
              {(totalGenderCount?.totalMale || 0) +
                (totalGenderCount?.totalFemale || 0)}
            </Paragraph>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10} justify="space-between" align="center">
        <Col span={12}>Guest Extending</Col>
        <Col span={12}>
          <Form.Item
            rules={[
              {
                required: true,
                message: `Please input Guest Extending`,
              },
            ]}
            name={["lengthOfStay", "guestExtending"]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10} justify="space-between" align="center">
        <Col span={12}>Total Guest Night</Col>
        <Col span={12}>
          <Form.Item>
            <Paragraph style={{ paddingLeft: 12 }}>{totalGuestNight}</Paragraph>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={10} justify="space-between" align="center">
        <Col span={12}>Total Male</Col>
        <Col span={12}>
          <Form.Item>
            <Paragraph style={{ paddingLeft: 12 }}>
              {totalGenderCount?.totalMale || 0}
            </Paragraph>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={10} justify="space-between" align="center">
        <Col span={12}>Total Female</Col>
        <Col span={12}>
          <Form.Item>
            <Paragraph style={{ paddingLeft: 12 }}>
              {totalGenderCount?.totalFemale || 0}
            </Paragraph>
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Button
            htmlType="reset"
            size="large"
            style={{ backgroundColor: COLORS.blue1 }}
          >
            RESET
          </Button>
        </Col>
        <Col span={12} style={{ justifyContent: "flex-end", display: "flex" }}>
          <Form.Item>
            <Button
              size="large"
              htmlType="submit"
              style={{ backgroundColor: COLORS.orange }}
            >
              SAVE
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default Index;
